export function getErrorMessage(error, fallback = 'Something went wrong.') {
  if (!error) return fallback;

  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  if (typeof error?.data?.message === 'string' && error.data.message.trim()) {
    return error.data.message;
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message;
  }

  return fallback;
}

export default getErrorMessage;
